import { NavLink, Outlet, Navigate, Link } from "react-router-dom";
import { TmdbMatchBanner } from "../../components/admin/TmdbMatchBanner";
import { useAuth } from "../../context/AuthContext";
import {
  LayoutDashboard,
  FileText,
  Film,
  ScrollText,
  Settings2,
  Users,
  Mail,
  LogOut,
  ExternalLink,
  ShieldCheck,
  Activity,
  Send,
  FilePlus2,
} from "lucide-react";

const nav = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true, testId: "admin-nav-home" },
  { to: "/admin/engagement", label: "Engagement", icon: Activity, testId: "admin-nav-engagement" },
  { to: "/admin/sorties-manuelles", label: "Sorties manuelles", icon: FilePlus2, testId: "admin-nav-manual-releases" },
  { to: "/admin/newsletter", label: "Newsletter", icon: Send, testId: "admin-nav-newsletter" },
  { to: "/admin/articles", label: "Articles", icon: FileText, testId: "admin-nav-articles" },
  { to: "/admin/sorties", label: "Sorties (TMDB)", icon: Film, testId: "admin-nav-sorties" },
  { to: "/admin/audit-couverture", label: "Audit couverture", icon: ShieldCheck, testId: "admin-nav-audit" },
  { to: "/admin/messages", label: "Messages", icon: Mail, testId: "admin-nav-messages" },
  { to: "/admin/historique", label: "Historique sync", icon: ScrollText, testId: "admin-nav-logs" },
  { to: "/admin/utilisateurs", label: "Rédacteurs", icon: Users, testId: "admin-nav-users" },
  { to: "/admin/reglages", label: "Réglages", icon: Settings2, testId: "admin-nav-settings" },
];

export const AdminLayout = () => {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-neutral-500 text-sm">
        Chargement…
      </div>
    );
  }
  if (!user || user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="flex min-h-screen bg-[var(--bg-cream)]">
      <aside
        data-testid="admin-sidebar"
        className="hidden md:flex md:w-64 shrink-0 flex-col border-r border-[var(--line)] bg-white sticky top-0 h-screen"
      >
        <Link to="/" className="px-6 py-6 border-b border-[var(--line)] block">
          <span className="brand-mark text-xl">ROUGEPREMIERE</span>
          <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-400 mt-1">
            Rédaction
          </div>
        </Link>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {nav.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                  isActive
                    ? "bg-[var(--red-soft)] text-[var(--red)] font-medium"
                    : "text-neutral-700 hover:bg-[var(--bg-cream)]"
                }`
              }
            >
              <l.icon className="h-4 w-4" />
              <span>{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-4 border-t border-[var(--line)]">
          <Link
            to="/"
            className="flex items-center gap-2 text-xs text-neutral-500 hover:text-[var(--red)] mb-3"
          >
            <ExternalLink className="h-3 w-3" /> Voir le site public
          </Link>
          <div className="text-[10px] uppercase tracking-widest text-neutral-400">
            Connecté
          </div>
          <div className="text-sm text-neutral-900 truncate mt-0.5">{user.email}</div>
          <button
            onClick={logout}
            data-testid="admin-logout"
            className="mt-3 text-xs text-neutral-500 hover:text-[var(--red)] inline-flex items-center gap-1"
          >
            <LogOut className="h-3 w-3" /> Se déconnecter
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <div className="md:hidden sticky top-0 z-30 flex items-center justify-between px-4 py-3 border-b border-[var(--line)] bg-white">
          <Link to="/" className="brand-mark text-lg">
            ROUGEPREMIERE
          </Link>
          <button onClick={logout} className="text-xs text-neutral-500">Déconnexion</button>
        </div>
        <div className="px-5 md:px-10 py-8 md:py-10 max-w-[1400px] w-full mx-auto">
          <TmdbMatchBanner />
          <Outlet />
        </div>
      </main>
    </div>
  );
};
